import SignupClientBase from '../interface/signupClientBase';
import {responseToError, HTTPError} from '@nuskin/http-client/errors';
import SignupSchema from '../model/signup-schema';
import {Market} from '../model/market';
import {SignupType} from '../model/signup-type';
import mockSchema from '../resources/mock-schema.json';
const signupSchema = new SignupSchema(mockSchema);

/**
 * Mock signup client implementation for offline usage and testing
 * @extends SignupClientBase
 */
export default class MockSignupClient extends SignupClientBase {
    /** @inheritdoc */
    async sponsorLookup(sponsorId) {
        const sponsors = [];
        if (sponsorId === 'US1111111') {
            sponsors.push({
                'id': 'US1111111',
                'firstName': 'DEBORAH',
                'lastName': 'KENIGSBERG',
                'profileImageUrl': 'https://'
            });
        } else if (sponsorId === 'US2222222') {
            throw responseToError({status: 500});
        }
        return sponsors;
    }

    /** @inheritdoc */
    async getSponsorAccounts(sponsorId) {
        const sponsorAccounts = {
            displayName: 'Fake Sponsor',
            profileImageUrl: null,
            accounts: [{
                id: sponsorId,
                type: 'parent'
            }]
        };
        if (sponsorId === 'US1111111') {
            sponsorAccounts.accounts.push({
                id: `${sponsorId}BB`,
                type: 'business-builder'
            });
        } else if (sponsorId === 'US2222222') {
            throw responseToError({status: 404});
        }
        return sponsorAccounts;
    }

    /** @inheritdoc */
    async getSignupSchema(market, signupType, language) {
        switch (signupType) {
            case SignupType.BRAND_AFFILIATE:
                switch (market) {
                    case 'US':
                        return signupSchema;
                    case 'RU':
                        throw new HTTPError({status: 404}, 'No configuration found');
                    default:
                        return signupSchema;
                }
            default:
                throw new Error('Unknown signup type: ' +signupType);
        }
    }

    /** @inheritdoc */
    async createAccount(market, signupType, language, modelObject) {
        switch (market) {
            case Market.CZ:
                throw new HTTPError({status: 500, message: 'Unknown Error for signupType: ' +signupType});
            case Market.RU:
                throw new HTTPError({status: 400, message: 'Bad data error'});
            default:
                return {
                    accountId: 'US5555555',
                    EID: 'abcd'
                };
        }
    }

    /** @inheritdoc */
    async createGuestAccount(market, language, guestData) {
        switch (market) {
            case Market.CZ:
                throw new HTTPError({status: 500, message: 'Unknown Error for guest signupType: '});
            case Market.RU:
                throw new HTTPError({status: 400, message: 'Bad data error'});
            default:
                return {
                    ID: 'US5555555',
                    Messages: [],
                    EID: 'abcd'
                };
        }
    }
}

